import React, { useState, useEffect } from "react";
import Sidebar from "../components/sidebar";
import { AuthProvider } from "../../../context/AuthContext.js";
import ClasesModal from "./ClasesModal.jsx";
import "./clases.css";

const API_URL = "https://iglesiaevangelicadelafe.com/api-church/lessons.php";
const BASE_URL = "https://iglesiaevangelicadelafe.com/api-church/";
const AUTH_CODE = "crunchypancakes4791@";

export default function Clases() {
  const [lessons, setLessons] = useState([]);
  const [filter, setFilter] = useState("Todas");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingLesson, setEditingLesson] = useState(null);

  useEffect(() => {
    fetchLessons();
  }, []);

  const fetchLessons = async () => {
    try {
      const response = await fetch(API_URL);
      const data = await response.json();
      if (data.success) {
        setLessons(data.data);
      } else {
        alert("Error al cargar clases: " + data.message);
      }
    } catch (error) {
      console.error("Error fetching lessons:", error);
    }
  };

  const handleSaveLesson = async (lessonData) => {
    const formData = new FormData();
    formData.append("authCode", AUTH_CODE);
    formData.append("title", lessonData.title);
    formData.append("description", lessonData.description);
    formData.append("category", lessonData.category);

    if (lessonData.id) {
      formData.append("action", "edit");
      formData.append("id", lessonData.id);
    } else {
      formData.append("action", "create");
    }

    if (lessonData.file) {
      formData.append("file", lessonData.file);
    }

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();

      if (data.success) {
        setIsModalOpen(false);
        setEditingLesson(null);
        fetchLessons(); // recargar
      } else {
        alert("Error al guardar: " + data.message);
      }
    } catch (error) {
      alert("Error de red al guardar la clase");
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("¿Seguro que deseas eliminar esta clase? Esta acción no se puede deshacer.")) {
      return;
    }

    const formData = new FormData();
    formData.append("authCode", AUTH_CODE);
    formData.append("action", "delete");
    formData.append("id", id);

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.success) {
        fetchLessons();
      } else {
        alert("Error al eliminar: " + data.message);
      }
    } catch (error) {
      alert("Error de red al eliminar la clase");
    }
  };

  const openEditModal = (lesson) => {
    setEditingLesson(lesson);
    setIsModalOpen(true);
  };

  const openNewModal = () => {
    setEditingLesson(null);
    setIsModalOpen(true);
  };

  const filteredLessons = filter === "Todas"
    ? lessons
    : lessons.filter(l => l.category === filter);

  return (
    <div className="dashboard">
      <Sidebar />
      <div className="dashboardContent classesContent">
        <AuthProvider>
          <div className="classesHeader">
            <div>
              <h1 className="dashboardTitle">Clases Bíblicas</h1>
              <p className="dashboardSubtitle">Administra y sube planes de estudio en PDF</p>
            </div>
            <div className="classesControls">
              <select
                className="categorySelect"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              >
                <option value="Todas">Todas las categorías</option>
                <option value="Crecimiento Espiritual">Crecimiento Espiritual</option>
                <option value="Panorama biblico">Panorama biblico</option>
                <option value="Nueva vida">Nueva vida</option>
                <option value="Seminarios">Seminarios</option>
                <option value="Predicas">Predicas</option>
              </select>
              <button className="addLessonBtn" onClick={openNewModal}>
                + Nueva Clase
              </button>
            </div>
          </div>

          <div className="lessonsGrid">
            {filteredLessons.map(lesson => (
              <div key={lesson.id} className="lessonCard">
                <span className="lessonTag">{lesson.category}</span>
                <h3 className="lessonTitle">{lesson.title}</h3>
                <p className="lessonDesc">
                  {lesson.description || "Sin descripción proporcionada."}
                </p>

                <div className="lessonActions">
                  <a
                    href={`${BASE_URL}${lesson.file_url}`}
                    target="_blank"
                    rel="noreferrer"
                    className="actionBtn viewBtn"
                  >
                    📄 Ver PDF
                  </a>
                  <button onClick={() => openEditModal(lesson)} className="actionBtn editBtn">
                    ✏️ Editar
                  </button>
                  <button onClick={() => handleDelete(lesson.id)} className="actionBtn deleteBtn">
                    🗑️ Borrar
                  </button>
                </div>
              </div>
            ))}

            {filteredLessons.length === 0 && (
              <p style={{ gridColumn: "1 / -1", textAlign: "center", color: "#666" }}>
                No hay clases {filter !== "Todas" ? `en la categoría "${filter}"` : "subidas aún."}
              </p>
            )}
          </div>

          <ClasesModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onSave={handleSaveLesson}
            editingLesson={editingLesson}
          />
        </AuthProvider>
      </div>
    </div>
  );
}
